import PropTypes from 'prop-types';

export default {
  partner_rewards_name: PropTypes.string,
  clearDiscountInReservationFlow: PropTypes.func,
};
